var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.9C20.1688 13.9 19.9 14.1688 19.9 14.5V16C19.9 16.7718 19.2718 17.4 18.5 17.4H5.5C4.72823 17.4 4.1 16.7718 4.1 16V14.5C4.1 14.1688 3.83123 13.9 3.5 13.9C3.16877 13.9 2.9 14.1688 2.9 14.5V16C2.9 17.4343 4.0668 18.6 5.5 18.6H18.5C19.9332 18.6 21.1 17.4343 21.1 16V14.5C21.1 14.1688 20.8312 13.9 20.5 13.9Z",
    fill: "#59C857",
    stroke: "#59C857",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6002 13.0516V3.5C12.6002 3.16877 12.3315 2.9 12.0002 2.9C11.669 2.9 11.4002 3.16877 11.4002 3.5V13.0516L10.0079 11.6593C9.77389 11.4252 9.39358 11.4252 9.15952 11.6593C8.92547 11.8933 8.92547 12.2737 9.15952 12.5077L11.5765 14.9247C11.6338 14.982 11.7012 15.0267 11.7741 15.0558C11.8454 15.0844 11.923 15.1 12.0002 15.1C12.0719 15.1 12.1422 15.0869 12.2091 15.062H12.2158L12.237 15.0514C12.2413 15.0493 12.2451 15.047 12.2483 15.0448C12.3112 15.0168 12.3722 14.9775 12.4253 14.9234C12.4254 14.9232 12.4256 14.9231 12.4257 14.9229L14.9249 12.4237C15.159 12.1897 15.159 11.8093 14.9249 11.5753C14.6909 11.3412 14.3106 11.3412 14.0765 11.5753L12.6002 13.0516ZM12.2654 15.0307C12.2658 15.0303 12.2655 15.0306 12.2648 15.0314L12.2654 15.0307Z",
    fill: "#59C857",
    stroke: "#59C857",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b9049336ebc53a5a67d418504d765bb0.svg";
export { ForwardRef as ReactComponent };